import { render, staticRenderFns } from "./IncomeTaxReport.vue?vue&type=template&id=40d3fefb&scoped=true"
import script from "./IncomeTaxReport.vue?vue&type=script&lang=js"
export * from "./IncomeTaxReport.vue?vue&type=script&lang=js"
import style0 from "./IncomeTaxReport.vue?vue&type=style&index=0&id=40d3fefb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d3fefb",
  null
  
)

export default component.exports